import CatRootModulePropertiesPane from '../_CAT_ROOT_MODULE/CatRootModulePropertiesPane.jsx'

export default function PropertiesPaneCatRootBm(props) {
    return (
        <CatRootModulePropertiesPane
            {...props}
        />
    )
}
